import { MasterDialog } from "#common/Dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { jobProfilePost } from "#job-profile/services/api"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Stack, Typography } from "@mui/material"
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import Box from "@mui/material/Box"
import { useCallback, useEffect, useMemo, useState } from "react"
import { toast } from "react-toastify"
import { JobProfileSkillsFormList } from "../job-profile- skills/JobProfileSkillsForm"
import { JobProfileToolsFormList } from "../job-profile- tools/JobProfileToolsForm"
import { JobProfileCompetencesFormList } from "../job-profile-competences/JobProfileCompetencesForm"
import { JobProfileInteractionFormList } from "../job-profile-interaction/JobProfileInteractionForm"
import { JobProfileKpisFormList } from "../job-profile-kpis/JobProfileKpisForm"
import { JobProfileResponsibilitiesFormList } from "../job-profile-responsibilities/JobProfileResponsibilitiesForm"
import JobProfileForm from "../job-profile/JobProfileForm"

export default function JobProfileFormNew({ getData }) {
	const [interactions, setInteractions] = useState([])
	const [skills, setSkills] = useState([])
	const [responsibilities, setResponsibilities] = useState([])
	const [tools, setTools] = useState([])
	const [kpis, setKpis] = useState([])
	const [competences, setCompetences] = useState([])
	const [profile, setProfile] = useState({})

	const [expanded, setExpanded] = useState("datosGenerales")
	const handleChangePanel = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false)
	}
	useEffect(() => {
		if (typeof getData === "function")
			getData({
				responsibilities,
				tools: tools.map((t) => t.id),
				kpis,
				competences,
				profile,
				interactions,
				skills,
			})
	}, [getData, responsibilities, tools, kpis, competences, profile, interactions, skills])

	return (
		<Stack direction={"column"} spacing={2}>
			<AccordionPerfil
				{...{
					label: "Datos Generales",
					name: "datosGenerales",
					expanded,
					handleChangePanel,
				}}
			>
				<JobProfileForm setValue={setProfile} value={profile} />
			</AccordionPerfil>

			<AccordionPerfil
				{...{
					label: "RESPONSABILIDADES | TAREAS",
					name: "datosResponsabilidades",
					expanded,
					handleChangePanel,
				}}
			>
				<JobProfileResponsibilitiesFormList
					value={responsibilities}
					setValue={setResponsibilities}
				/>
			</AccordionPerfil>
			<AccordionPerfil
				{...{
					label: "RELACIONES INTERNOS Y/O EXTERNAS",
					name: "datosInteraccionesInternas",
					expanded,
					handleChangePanel,
				}}
			>
				<JobProfileInteractionFormList setValue={setInteractions} value={interactions} />
			</AccordionPerfil>
			<AccordionPerfil
				{...{
					label: "indicadores de éxito kpi´s",
					name: "datosKPIs",
					expanded,
					handleChangePanel,
				}}
			>
				<JobProfileKpisFormList setValue={setKpis} value={kpis} />
			</AccordionPerfil>
			<AccordionPerfil
				{...{
					label: "Competencias",
					name: "datosCompetencias",
					expanded,
					handleChangePanel,
				}}
			>
				<JobProfileCompetencesFormList
					{...{ value: competences, setValues: setCompetences }}
				/>
			</AccordionPerfil>
			<AccordionPerfil
				{...{
					label: "capacidades profesionales",
					name: "capacidadesProfesionales",
					expanded,
					handleChangePanel,
				}}
			>
				<JobProfileSkillsFormList setValue={setSkills} value={skills} />
			</AccordionPerfil>

			<AccordionPerfil
				{...{
					label: "Herramientas de Trabajo",
					name: "datosHerramientas",
					expanded,
					handleChangePanel,
				}}
			>
				<JobProfileToolsFormList value={tools} setValue={setTools} />
			</AccordionPerfil>
		</Stack>
	)
}

const AccordionPerfil = ({ label, name, expanded, handleChangePanel, children }) => {
	return (
		<Accordion
			expanded={expanded === name}
			onChange={handleChangePanel(name)}
			sx={{
				"&:before": { display: "none" }, // elimina la línea superior
			}}
		>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls="panel1a-content"
				id="panel1a-header"
			>
				<Box>
					<Typography
						// component="span"
						sx={{ textTransform: "uppercase", fontSize: 20, color: "#1d3454" }}
					>
						{label}
					</Typography>
				</Box>
			</AccordionSummary>
			<AccordionDetails>{children}</AccordionDetails>
		</Accordion>
	)
}

export function JobProfileFormNewDialog({ open, setOpen, reload }) {
	const success = () => {
		setOpen(false)
		if (typeof reload === "function") reload()
	}
	const { fetch: post } = useApiSend(jobProfilePost, { success })
	const [perfil, setPerfil] = useState({})

	const handleSendData = useCallback(() => {
		let keys = Object.keys(perfil.profile)
		keys = keys.filter((key) => !["viajar", "reporta_a", "jefe_inmediato"].includes(key))

		for (let index = 0; index < keys.length; index++) {
			if (perfil.profile[keys[index]] === "") {
				toast.error("El campo " + keys[index] + " es requerido")
				return
			}
		}
		post(perfil)
	}, [perfil, post])

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: () => setOpen(false),
			},
			{
				label: "Crear Perfil",
				onClick: handleSendData,
			},
		],
		[handleSendData, setOpen]
	)

	return (
		<MasterDialog
			{...{ open, setOpen, title: "Creación De Perfil Puesto", buttons }}
			maxWidth="md"
		>
			<JobProfileFormNew getData={setPerfil} />
		</MasterDialog>
	)
}
